import axios from 'axios'
import INotification from '@interfaces/INotification'

export const getAll = () =>
  axios.get<{ data: INotification[] }>('v1/catalogo/notifications')

export const markAllRead = () =>
  axios.post('v1/catalogo/notifications/mark-all-read')

export const markRead = (id: string) =>
  axios.post(`v1/catalogo/notifications/${id}/mark-read`)
